// =========================
// PricingControlsPanel — v1.2.0 Workstream 4 Phase 2 (Admin Portal)
//
// Read-only view of the three paid tiers: display price, whether each tier's
// Stripe price ID is wired into the frontend env, and a link to the Stripe
// dashboard where pricing actually lives. Pure render — no data fetch, no
// useEffect, no lib/admin call. Rendered as a tab inside AdminDashboard; the
// dashboard shell supplies layout + background.
//
// The `price` strings here are STATIC display labels only — the authoritative
// amount lives in the Stripe product, edited in the Stripe dashboard. This
// panel never reads or writes the real amount; it only reports whether the
// REACT_APP_STRIPE_PRICE_ID_* env var is present (configured) or not.
//
// Env note: REACT_APP_* vars are inlined at build in production but read from
// process.env at runtime in CRA test mode (same pattern as AdminRoute).
// =========================

import React from 'react';

const STRIPE_DASHBOARD_URL = 'https://dashboard.stripe.com/products';

const TIERS_CONFIG = [
  { label: 'Investor',     envVar: 'REACT_APP_STRIPE_PRICE_ID_INVESTOR',     price: '$49/mo' },
  { label: 'Professional', envVar: 'REACT_APP_STRIPE_PRICE_ID_PROFESSIONAL', price: '$99/mo' },
  { label: 'Enterprise',   envVar: 'REACT_APP_STRIPE_PRICE_ID_ENTERPRISE',   price: '$249/mo' },
];

export default function PricingControlsPanel() {
  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
        {TIERS_CONFIG.map((tier) => {
          const configured = Boolean(process.env[tier.envVar]);
          return (
            <div
              key={tier.label}
              className="card"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 'var(--space-4)',
                flexWrap: 'wrap',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
                <span
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: 'var(--text-lg)',
                    fontWeight: 'var(--weight-bold)',
                    color: 'var(--color-white)',
                  }}
                >
                  {tier.label}
                </span>
                <span style={{ fontSize: 'var(--text-sm)', color: 'var(--color-steel)' }}>
                  {tier.price}
                </span>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', flexWrap: 'wrap' }}>
                <span className={`badge ${configured ? 'badge-active' : 'badge-pass'}`}>
                  {configured ? 'Configured' : 'Not configured'}
                </span>
                <a
                  href={STRIPE_DASHBOARD_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary"
                >
                  View in Stripe Dashboard
                </a>
              </div>
            </div>
          );
        })}
      </div>

      <p
        style={{
          fontSize: 'var(--text-sm)',
          color: 'var(--color-steel-lt)',
          lineHeight: 'var(--leading-normal)',
          margin: 0,
        }}
      >
        To change pricing, update Stripe products directly. Price IDs are
        configured via environment variables.
      </p>
    </div>
  );
}
